import DateBadge from '../../DateBadge';
import useGroupAction from '../useGroupAction';
import { TaskGroupSummary } from '../../types';
import getGroupDisplay from '../../utils/getGroupDisplay';
import isOverdue from '../../utils/isOverdue';
import priorityToDateBadgeIcon from '../../utils/priorityToDateBadgeIcon';
import TaskCardShell from '../../common/TaskCardShell';

interface TaskGroupCardProps {
    group: TaskGroupSummary;
    // Injected by FeedItemTransition while this card plays its completion exit animation.
    isCompleting?: boolean;
}

export default function TaskGroupCard({ group, isCompleting }: Readonly<TaskGroupCardProps>) {
    const { onCtaClick, actionSurface } = useGroupAction(group);
    const { title, description, ctaLabel } = getGroupDisplay(group);
    const overdue = isOverdue(group.next_due_date);

    return (
        <>
            <TaskCardShell
                title={title}
                ctaLabel={ctaLabel}
                onCtaClick={onCtaClick}
                dateBadge={
                    group.next_due_date ? (
                        <DateBadge date={group.next_due_date} icon={priorityToDateBadgeIcon(group.priority)} />
                    ) : undefined
                }
                description={description}
                overdue={overdue}
                isCompleting={isCompleting}
            />
            {actionSurface}
        </>
    );
}
